"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncProperty = void 0;

var PreconditionFailure_1 = require("../precondition/PreconditionFailure");

var IRawProperty_1 = require("./IRawProperty");

var GlobalParameters_1 = require("../runner/configuration/GlobalParameters");

var Stream_1 = require("../../stream/Stream");

var Converters_1 = require("../arbitrary/definition/Converters");

var NoUndefinedAsContext_1 = require("../../arbitrary/_internals/helpers/NoUndefinedAsContext");

var AsyncProperty = /*#__PURE__*/function () {
  function AsyncProperty(rawArb, predicate) {
    _classCallCheck(this, AsyncProperty);

    this.predicate = predicate;

    var _ref = (0, GlobalParameters_1.readConfigureGlobal)() || {},
        asyncBeforeEach = _ref.asyncBeforeEach,
        asyncAfterEach = _ref.asyncAfterEach,
        beforeEach = _ref.beforeEach,
        afterEach = _ref.afterEach;

    if (asyncBeforeEach !== undefined && beforeEach !== undefined) {
      throw Error('Global "asyncBeforeEach" and "beforeEach" parameters can\'t be set at the same time when running async properties');
    }

    if (asyncAfterEach !== undefined && afterEach !== undefined) {
      throw Error('Global "asyncAfterEach" and "afterEach" parameters can\'t be set at the same time when running async properties');
    }

    this.beforeEachHook = asyncBeforeEach || beforeEach || AsyncProperty.dummyHook;
    this.afterEachHook = asyncAfterEach || afterEach || AsyncProperty.dummyHook;
    this.arb = (0, Converters_1.convertToNext)(rawArb);
  }

  _createClass(AsyncProperty, [{
    key: "isAsync",
    value: function isAsync() {
      return true;
    }
  }, {
    key: "generate",
    value: function generate(mrng, runId) {
      var value = this.arb.generate(mrng, runId != null ? (0, IRawProperty_1.runIdToFrequency)(runId) : undefined);
      return (0, NoUndefinedAsContext_1.noUndefinedAsContext)(value);
    }
  }, {
    key: "shrink",
    value: function shrink(value) {
      if (value.context === undefined && !this.arb.canShrinkWithoutContext(value.value_)) {
        return Stream_1.Stream.nil();
      }

      var safeContext = value.context !== NoUndefinedAsContext_1.UndefinedContextPlaceholder ? value.context : undefined;
      return this.arb.shrink(value.value_, safeContext).map(NoUndefinedAsContext_1.noUndefinedAsContext);
    }
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(v) {
        var output;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.beforeEachHook();

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return this.predicate(v);

              case 5:
                output = _context.sent;
                return _context.abrupt("return", output == null || output === true ? null : 'Property failed by returning false');

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);

                if (!PreconditionFailure_1.PreconditionFailure.isFailure(_context.t0)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", _context.t0);

              case 13:
                if (!(_context.t0 instanceof Error && _context.t0.stack)) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", "".concat(_context.t0, "\n\nStack trace: ").concat(_context.t0.stack));

              case 15:
                return _context.abrupt("return", "".concat(_context.t0));

              case 16:
                _context.prev = 16;
                _context.next = 19;
                return this.afterEachHook();

              case 19:
                return _context.finish(16);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9, 16, 20]]);
      }));

      function run(_x) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }, {
    key: "beforeEach",
    value: function beforeEach(hookFunction) {
      var previousBeforeEachHook = this.beforeEachHook;

      this.beforeEachHook = function () {
        return hookFunction(previousBeforeEachHook);
      };

      return this;
    }
  }, {
    key: "afterEach",
    value: function afterEach(hookFunction) {
      var previousAfterEachHook = this.afterEachHook;

      this.afterEachHook = function () {
        return hookFunction(previousAfterEachHook);
      };

      return this;
    }
  }]);

  return AsyncProperty;
}();

exports.AsyncProperty = AsyncProperty;

AsyncProperty.dummyHook = function () {};